// Breadcrumbs are now integrated into menu items

// Helper function to get breadcrumbs by path
export const getBreadcrumbsByPath = (path) => {
  // Search in admin menu items
  for (const item of adminMenuItems) {
    if (item.path === path && item.breadcrumbs) {
      return item.breadcrumbs;
    }
    if (item.subItems) {
      for (const subItem of item.subItems) {
        if (subItem.path === path && subItem.breadcrumbs) {
          return subItem.breadcrumbs;
        }
      }
    }
  }

  // Return default breadcrumb if not found
  return [{ label: "Home", path: "/" }];
};


// Navigation paths
export const paths = {
  dashboard: "/dashboard",
  orgManagement: "/org-management",
  orgStructure: "/org-management/org-structure",
  legalEntities: "/org-management/org-structure/legal-entities",
  location: "/org-management/org-structure/location",
  department: "/org-management/org-structure/department",
  designation: "/org-management/org-structure/designation",
  addDesignation: "/org-management/org-structure/add-designation",
  myOrg: "/org-management/my-org",
  companyDetails: "/settings/company-details",
  attendance: "/attendance",
  leaves: "/leaves",
  reservations: "/reservations",
  billing: "/billing",
  settings: "/settings",
  help: "/help",
};


// Sidebar menu items for Admin role
export const adminMenuItems = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: "Dashboard",
    path: "/dashboard",
    breadcrumbs: [{ label: "Dashboard", path: "/dashboard" }],
  },
  {
    id: "my-team",
    label: "My Team",
    icon: "People",
    hasChildren: true,
    path: "/my-team",
    breadcrumbs: [{ label: "My Team", path: "/my-team" }],

    subItems: [
      {
        id: "overview",
        label: "Overview",
        path: "/my-team/overview",
        breadcrumbs: [
          { label: "My Team", path: "/my-team" },
          { label: "Overview", path: "/my-team/overview" },
        ],
      },
      {
        id: "employee-directory",
        label: "Employee Directory",
        path: "/my-team/employee-directory",
        breadcrumbs: [
          { label: "My Team", path: "/my-team" },
          { label: "Employee Directory", path: "/my-team/employee-directory" },
        ],
        tabs: [
          {
            label: "Personal Information",
            value: "personal-information",
            breadcrumbs: [
              { label: "My Team", path: "/my-team" },
              { label: "Employee Directory", path: "/my-team/employee-directory" },
              { label: "Add Employee", path: "/my-team/add-employee" },
              { label: "Personal Information", path: "/my-team/add-employee/personal-information" },
            ],
          },
          {
            label: "Education",
            value: "education",
            breadcrumbs: [
              { label: "My Team", path: "/my-team" },
              { label: "Employee Directory", path: "/my-team/employee-directory" },
              { label: "Add Employee", path: "/my-team/add-employee" },
              { label: "Education", path: "/my-team/add-employee/education" },
            ],
          },
          {
            label: "Previous Employment",
            value: "previous-employment",
            breadcrumbs: [
              { label: "My Team", path: "/my-team" },
              { label: "Employee Directory", path: "/my-team/employee-directory" },
              { label: "Add Employee", path: "/my-team/add-employee" },
              { label: "Previous Employment", path: "/my-team/add-employee/previous-employment" },
            ],
          },
          {
            label: "Job Details",
            value: "job-details",
            breadcrumbs: [
              { label: "My Team", path: "/my-team" },
              { label: "Employee Directory", path: "/my-team/employee-directory" },
              { label: "Add Employee", path: "/my-team/add-employee" },
              { label: "Job Details", path: "/my-team/add-employee/job-details" },
            ],
          },
          {
            label: "CTC Information",
            value: "compensation-benefits",
            breadcrumbs: [
              { label: "My Team", path: "/my-team" },
              { label: "Employee Directory", path: "/my-team/employee-directory" },
              { label: "Add Employee", path: "/my-team/add-employee" },
              { label: "CTC Information", path: "/my-team/add-employee/compensation-benefits" },
            ],
          },
        ],
      },
      {
        id: "pending-documents",
        label: "Pending Documents",
        path: "/my-team/pending-documents",
        breadcrumbs: [
          { label: "My Team", path: "/my-team" },
          { label: "Pending Documents", path: "/my-team/pending-documents" },
        ],
      },
      // {
      //   id: "onboarding",
      //   label: "Onboarding",
      //   path: "/my-team/onboarding",
      //   breadcrumbs: [
      //     { label: "My Team", path: "/my-team" },
      //     { label: "Onboarding", path: "/my-team/onboarding" },
      //   ],
      // },
      {
        id: "pre-onboarding",
        label: "Pre-Onboarding",
        path: "/my-team/pre-onboarding",
        breadcrumbs: [
          { label: "My Team", path: "/my-team" },
          { label: "Pre-Onboarding", path: "/my-team/pre-onboarding" },
        ],
        tabs: [
          {
            label: "Document",
            value: "document",
            breadcrumbs: [
              { label: "My Team", path: "/my-team" },
              { label: "Onboarding", path: "/my-team/pre-onboarding" },
              { label: "Document", path: "/my-team/pre-onboarding/document" },
            ],
          },
          {
            label: "Joining Form",
            value: "joining-form",
            breadcrumbs: [
              { label: "My Team", path: "/my-team" },
              { label: "Pre-Onboarding", path: "/my-team/pre-onboarding" },
              { label: "Joining Form", path: "/my-team/pre-onboarding/joining-form" },
            ],
          },
          {
            label: "BGV",
            value: "bgv",
            breadcrumbs: [
              { label: "My Team", path: "/my-team" },
              { label: "Pre-Onboarding", path: "/my-team/pre-onboarding" },
              { label: "BGV", path: "/my-team/pre-onboarding/bgv" },
            ],
          },
          {
            label: "Offer Status",
            value: "offer-status",
            breadcrumbs: [
              { label: "My Team", path: "/my-team" },
              { label: "Pre-Onboarding", path: "/my-team/pre-onboarding" },
              { label: "Offer Status", path: "/my-team/pre-onboarding/offer-status" },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "org-management",
    label: "Org Management",
    icon: "Business",
    hasChildren: true,
    breadcrumbs: [{ label: "Org Management", path: "/org-management" }],
    subItems: [
      {
        id: "org-structure",
        label: "Org Structure",
        path: "/org-management/org-structure",
        breadcrumbs: [
          { label: "Org Management", path: "/org-management" },
          { label: "Org Structure", path: "/org-management/org-structure" },
        ],
        tabs: [
          {
            label: "Legal Entities",
            value: "legal-entities",
            breadcrumbs: [
              { label: "Org Management", path: "/org-management" },
              { label: "Org Structure", path: "/org-management/org-structure" },
              {
                label: "Legal Entities",
                path: "/org-management/org-structure/legal-entities",
              },
            ],
          },
          {
            label: "Location",
            value: "location",
            breadcrumbs: [
              { label: "Org Management", path: "/org-management" },
              { label: "Org Structure", path: "/org-management/org-structure" },
              { label: "Location", path: "/org-management/org-structure/location" },
            ],
          },
          {
            label: "Department",
            value: "department",
            breadcrumbs: [
              { label: "Org Management", path: "/org-management" },
              { label: "Org Structure", path: "/org-management/org-structure" },
              { label: "Department", path: "/org-management/org-structure/department" },
            ],
          },
          {
            label: "Designation",
            value: "designation",
            breadcrumbs: [
              { label: "Org Management", path: "/org-management" },
              { label: "Org Structure", path: "/org-management/org-structure" },
              { label: "Designation", path: "/org-management/org-structure/designation" },
            ],
          },
        ],
      },
      {
        id: "org-setup",
        label: "Org Setup",
        path: "/org-management/org-setup",
        breadcrumbs: [
          { label: "Org Management", path: "/org-management" },
          { label: "Org Setup", path: "/org-management/org-setup" },
        ],
        tabs: [
          {
            label: "Personal Information",
            value: "personal-information",
            breadcrumbs: [
              { label: "Org Management", path: "/org-management" },
              { label: "Org Setup", path: "/org-management/org-setup" },
              {
                label: "Personal Information",
                path: "/org-management/org-setup/personal-information",
              },
            ],
          },
          {
            label: "Operational Information",
            value: "operational-information",
            breadcrumbs: [
              { label: "Org Management", path: "/org-management" },
              { label: "Org Setup", path: "/org-management/org-setup" },
              {
                label: "Operational Information",
                path: "/org-management/org-setup/operational-information",
              },
            ],
          },
          {
            label: "Legal Info",
            value: "legal-info",
            breadcrumbs: [
              { label: "Org Management", path: "/org-management" },
              { label: "Org Setup", path: "/org-management/org-setup" },
              {
                label: "Legal Info",
                path: "/org-management/org-setup/legal-info",
              },
            ],
          },
          {
            label: "Social Media Links",
            value: "social-media-links",
            breadcrumbs: [
              { label: "Org Management", path: "/org-management" },
              { label: "Org Setup", path: "/org-management/org-setup" },
              {
                label: "Social Media Links",
                path: "/org-management/org-setup/social-media-links",
              },
            ],
          },
          {
            label: "Onboarding Templates",
            value: "onboarding-templates",
            breadcrumbs: [
              { label: "Org Management", path: "/org-management" },
              { label: "Org Setup", path: "/org-management/org-setup" },
              {
                label: "Onboarding Templates",
                path: "/org-management/org-setup/onboarding-templates",
              },
            ],
          },
        ],
      },
      {
        id: "onboarding-templates",
        label: "Onboarding Templates",
        path: "/org-management/org-setup/onboarding-templates",
        breadcrumbs: [
          { label: "Org Management", path: "/org-management" },
          { label: "Org Setup", path: "/org-management/org-setup" },
          { label: "Onboarding Templates", path: "/org-management/org-setup/onboarding-templates" },
        ],
      },
      {
        id: "my-org",
        label: "My Organization",
        path: "/org-management/my-org",
        breadcrumbs: [
          { label: "Org Management", path: "/org-management" },
          { label: "My Organization", path: "/org-management/my-org" },
        ],
      },
      {
        id: "role-and-permission",
        label: "Role & Permission",
        path: "/org-management/role-and-permission",
        breadcrumbs: [
          { label: "Org Management", path: "/org-management" },
          { label: "Role & Permission", path: "/org-management/role-and-permission" },
        ],
      },
      // {
      //   id: "shift-schedule",
      //   label: "Shift & Schedule",
      //   path: "/org-management/shift-schedule",
      //   breadcrumbs: [
      //     { label: "Org Management", path: "/org-management" },
      //     { label: "Shift & Schedule", path: "/org-management/shift-schedule" },
      //   ],
      //   tabs: [
      //     {
      //       label: "Shifts",
      //       value: "shifts",
      //       breadcrumbs: [
      //         { label: "Org Management", path: "/org-management" },
      //         { label: "Shift & Schedule", path: "/org-management/shift-schedule" },
      //         { label: "Shifts", path: "/org-management/shift-schedule" },
      //       ],
      //     },
      //     {
      //       label: "Schedule",
      //       value: "schedule",
      //       breadcrumbs: [
      //         { label: "Org Management", path: "/org-management" },
      //         { label: "Shift & Schedule", path: "/org-management/shift-schedule" },
      //         { label: "Schedule", path: "/org-management/shift-schedule/schedule" },
      //       ],
      //     },
      //   ],
      // },
    ],
  },

  // {
  //   id: "attendance",
  //   label: "Attendance",
  //   icon: "AccessTime",
  //   path: "/attendance",
  //   breadcrumbs: [{ label: "Attendance", path: "/attendance" }],
  // },
  // {
  //   id: "leaves",
  //   label: "Leaves",
  //   icon: "EventNote",
  //   path: "/leaves",
  //   breadcrumbs: [{ label: "Leaves", path: "/leaves" }],
  // },
  // {
  //   id: "reservations",
  //   label: "Reservations",
  //   icon: "BookOnline",
  //   path: "/reservations",
  //   breadcrumbs: [{ label: "Reservations", path: "/reservations" }],
  // },
  // {
  //   id: "billing",
  //   label: "Billing & Usage",
  //   icon: "Receipt",
  //   path: "/billing",
  //   breadcrumbs: [{ label: "Billing & Usage", path: "/billing" }],
  // },
  // {
  //   id: "help",
  //   label: "Help & Support",
  //   icon: "HelpOutline",
  //   path: "/help",
  //   breadcrumbs: [{ label: "Help & Support", path: "/help" }],
  // },
  // {
  //   id: "settings",
  //   label: "Settings",
  //   icon: "Settings",
  //   path: "/settings",
  //   breadcrumbs: [{ label: "Settings", path: "/settings" }],
  //   subItems: [
  //     {
  //       id: "company-details",
  //       label: "Company Details",
  //       path: "/settings/company-details",
  //       breadcrumbs: [
  //         { label: "Settings", path: "/settings" },
  //         { label: "Company Details", path: "/settings/company-details" },
  //       ],
  //     },
  //   ],
  // },
];

// Sidebar menu items for Employee role
export const employeeMenuItems = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: "Dashboard",
    path: "/dashboard",
    breadcrumbs: [{ label: "Dashboard", path: "/dashboard" }],
  },
  {
    id: "profile",
    label: "Profile",
    icon: "People",
    path: "/profile",
    breadcrumbs: [{ label: "Profile", path: "/profile" }],
  },
  {
    id: "attendance",
    label: "Attendance",
    icon: "AccessTime",
    path: "/attendance",
    breadcrumbs: [{ label: "Attendance", path: "/attendance" }],
  },
  {
    id: "leaves",
    label: "Leaves",
    icon: "EventNote",
    path: "/leaves",
    breadcrumbs: [{ label: "Leaves", path: "/leaves" }],
  },
  {
    id: "help",
    label: "Help & Support",
    icon: "HelpOutline",
    path: "/help",
    breadcrumbs: [{ label: "Help & Support", path: "/help" }],
  },
  {
    id: "settings",
    label: "Settings",
    icon: "Settings",
    path: "/settings",
    breadcrumbs: [{ label: "Settings", path: "/settings" }],
  },
];
